module.exports = __webpack_public_path__ + "assets/img/13.93d21ac5.png";